<script setup lang="ts">
import { useTranslation } from 'i18next-vue';
import ConfirmationModal from './ConfirmationModal.vue';
import { confirmationInjectionKeys, type ConfirmationModalOptions } from './types';

const { t } = useTranslation();

const defaultOptions: ConfirmationModalOptions = {
  title: t('Confirmation'),
  text: t('Copy'),
  confirmButton: t('Confirm'),
  cancelButton: t('Cancel'),
  hideClose: true,
};
</script>

<template>
  <ConfirmationModal
    :defaultOptions="defaultOptions"
    :injectionKey="confirmationInjectionKeys.action"
  >
    <slot />
  </ConfirmationModal>
</template>
